import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import type { InProgressOrderModalProps } from '@components/modals/InProgressOrderModal/InProgressOrderModal.types';

const InProgressOrderModal = ({
  open,
  onClose,
  onContinuePreviousOrder,
  onStartNewOrder,
  isLoading = false,
}: InProgressOrderModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      variant="warning"
      data-backdrop-variant="blurred"
      className="resume-order-dialog"
    >
      <Stack className="warning-dialog-content">
        <Box className="warning-dialog-close" onClick={onClose}>
          <CloseIcon />
        </Box>

        <Typography variant="price.total" component="h2">
          Your Cart is Ready When You Are
        </Typography>
        <Typography variant="body.md" color="text.secondary">
          You have an order in progress at this service address. Want to pick up where you left off, or start a fresh
          order?
        </Typography>

        <Stack className="resume-order-actions" direction="row" gap="12px" pt="8px">
          <Button variant="editPlan" onClick={onStartNewOrder} disabled={isLoading}>
            <Typography variant="label.buttonEmphatic" color="inherit">
              START A NEW ORDER
            </Typography>
          </Button>
          <Button variant="contained" onClick={onContinuePreviousOrder} disabled={isLoading}>
            <Typography variant="label.buttonEmphatic" color="inherit">
              CONTINUE ORDER
            </Typography>
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};

export default InProgressOrderModal;
